import { registerHandler } from "../handler";
import { isUS } from "src/utils/userSegment";
import { LibCategories, waitForConsent } from "@utils/consent";
import { trackTask } from "src/utils/monitoring/events/tasks";
import visitTracker from "@noom/visit-tracker";
import { MedProductType } from "src/utils/constants";

const INTL_HEALTHLINE_REVENUE = 30;
const US_HEALTHLINE_REVENUE = 40;
const MED_HEALTHLINE_REVENUE = 50;

function getHealthlineUrl(isMedPurchaseIntent = false) {
  // For the healthline pixel the revenue is hardcoded.
  let revenue = INTL_HEALTHLINE_REVENUE;
  if (isMedPurchaseIntent) {
    revenue = MED_HEALTHLINE_REVENUE;
  } else if (isUS()) {
    revenue = US_HEALTHLINE_REVENUE;
  }

  const healthLineURL = new URL(
    "https://activation.healthline.com/api/member-offers/postback"
  );
  healthLineURL.searchParams.append(
    "clid",
    visitTracker.getTrackingParams().clid || "-1"
  );
  healthLineURL.searchParams.append("rev", revenue.toString());

  return healthLineURL.toString();
}

export default function registerHandlers() {
  registerHandler("purchase", () => {
    waitForConsent([LibCategories.targetingCookies]).then(() => {
      trackTask("HealthlinePurchase")
        .wrap(() =>
          fetch(getHealthlineUrl()).then((response) => {
            if (!response.ok) {
              throw new Error("Healthline pixel failed");
            }
          })
        )
        .catch(() => {
          /* NOP */
        });
    });
  });

  registerHandler("purchaseIntent", ({ medProductType }) => {
    waitForConsent([LibCategories.targetingCookies]).then(() => {
      if (medProductType !== MedProductType.HRT) {
        trackTask("HealthlinePurchaseIntent")
          .wrap(() =>
            fetch(getHealthlineUrl(true)).then((response) => {
              if (!response.ok) {
                throw new Error("Healthline pixel failed");
              }
            })
          )
          .catch(() => {
            /* NOP */
          });
      }
    });
  });
}
